namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class DealsLostReasonEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "Bad Timing", text: "Bad Timing" });
            this.addItem({ id: "Budget Issue", text: "Budget Issue" });
            this.addItem({ id: "Choose Competitor", text: "Choose Competitor" });
            this.addItem({ id: "Client's Internal Issue", text: "Client's Internal Issue" });
            this.addItem({ id: "No Response", text: "No Response" });
            this.addItem({ id: "Not Interested", text: "Not Interested" });
            this.addItem({ id: "Not Qualified", text: "Not Qualified" });
            this.addItem({ id: "Other", text: "Other" });
            this.addItem({ id: "Product Doesn't Fit Client's Need", text: "Product Doesn't Fit Client's Need" });
        }
    }
}